































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import version from "@/version";
import updateLog from "../../../update/updateLog";

@Component({})
export default class UpdateNotice extends Vue {
	@Prop({ type: Boolean, default: false })
	visible!: boolean;

	showNotice: boolean = this.visible;
	version: string = version;
	noticeList: { time: string; content: { title: string; list: string[] }[]; }[] = updateLog;
	@Watch("showNotice")
	visibleCopyChange(val: boolean) {
		this.$emit("update:visible", val);
	}

	@Watch("visible")
	visibleChange(val: boolean) {
		this.showNotice = val;
	}

	getTimeStamp(date: Date): string {
		date.setHours(date.getHours(), date.getMinutes() - date.getTimezoneOffset());
		return date.toISOString();
	}

	closeNotice() {
		this.showNotice = false;
		localStorage.setItem("showNotice", "false");
	}
}
